export default {
  SET_MEDICAL_CARD: 'SET_MEDICAL_CARD',
  SET_MEDICAL_CARD_ERROR: 'SET_MEDICAL_CARD_ERROR',
  SET_MEDICAL_CARD_LOADING: 'SET_MEDICAL_CARD_LOADING',
  SET_PHARMACY_CARD: 'SET_PHARMACY_CARD',
  SET_PHARMACY_CARD_ERROR: 'SET_PHARMACY_CARD_ERROR',
  SET_PHARMACY_CARD_LOADING: 'SET_PHARMACY_CARD_LOADING'
};
